import React from "react";
import startOfToday from "date-fns/startOfToday";

import './booking_bar.css';

import {blue, amber, grey, green} from "@mui/material/colors";
import {ButtonBase} from "@mui/material";
import {useNavigate} from "react-router-dom";


const colorStyle = {
    blue: {
        color: blue[400].contrastText,
        borderColor: blue[800],
        backgroundColor: blue[400],
    },
    amber: {
        color: amber[400].contrastText,
        borderColor: amber[800],
        backgroundColor: amber[400],
    },
        grey: {
        color: grey[400].contrastText,
        borderColor: grey[800],
        backgroundColor: grey[400],
    },
    green: {
        color: green[400].contrastText,
        borderColor: green[800],
        backgroundColor: green[400],
    }
}

const getColorStyle = (calendarItem) => {
    if (calendarItem.endDate < startOfToday() || !!calendarItem.checkOutAt){
        // Old or already completely check out
        return colorStyle.grey
    } else if (calendarItem.bookingDeposit && calendarItem.bookingPayed < calendarItem.bookingDeposit){
        // Deposit present but not payed
        return colorStyle.amber
    } else if (calendarItem.bookingPrice && calendarItem.bookingPayed >= calendarItem.bookingPrice){
        // Price present and payed
        return colorStyle.green
    } else{
        // Other cases
        return colorStyle.blue
    }
}

const BookingBar = (props) => {
    const {calendarItem, rightCut, leftCut, isCentralSegment} = props;
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        navigate(`/main/bookings/${calendarItem.bookingId}`);
    }

    const getLabel = () => {
        if (calendarItem.price){
            return `${calendarItem.fullName} (${calendarItem.price} €)`
        }
        return calendarItem.fullName;
    }

    return <ButtonBase onClick={handleClick}
                       className="booking-bar-button">
        <div className={`booking-bar ${rightCut ? 'right-cut' : ''} ${leftCut ? 'left-cut' : ''}`}
             style={getColorStyle(calendarItem)}>
            {isCentralSegment && getLabel()}
        </div>
    </ButtonBase>
}

export default BookingBar;